import { memo } from 'react';

import LightningIconSVG from '@/assets/lightning-filled-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const ILightningIcon = (props: Omit<IconProps, 'SVGComponent'>) => <Icon SVGComponent={LightningIconSVG} {...props} />;

export const LightningIcon = memo(ILightningIcon) as typeof ILightningIcon;
